import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    iframe: {
        minHeight: 500,
        width: "100%",
        border: "none",
    },
    container: {
        paddingTop: theme.spacing(2),
    },
}));
